export const auditCategories = [
  'summary',
  'gear_overview',
  'gear_upgrades',
  'enchantments',
  'vault',
  'raids_weekly',
  'raids_overall',
  'dungeons_weekly',
  'dungeons_overall',
  'collections',
  'reputations',
  'pvp',
] as const

type AuditCategory = typeof auditCategories[number]
export default AuditCategory
